import type React from 'react';

import { tv, type VariantProps } from 'tailwind-variants';

import BannerActions from './components/BannerActions';
import BannerContent from './components/BannerContent';
import BannerIcon from './components/BannerContent/components/BannerIcon';
import BannerText from './components/BannerContent/components/BannerText';

import cn from '../../utils/cn';

const infoVariants = tv({
  base: 'flex items-center justify-between rounded-md bg-primary/10 p-2.5',
  variants: {
    size: {
      condensed: 'min-h-10 px-5',
      default: 'min-h-16 p-5',
    },
    defaultVariants: {
      size: 'default',
    },
  },
});

type InfoVariants = VariantProps<typeof infoVariants>;

interface InfoContainerProps extends InfoVariants {
  children: React.ReactNode;
  className?: string;
}

const InfoBanner = ({
  children,
  className,
  size,
  ...props
}: InfoContainerProps) => (
  <div className={cn(infoVariants({ size }), className)} {...props}>
    {children}
  </div>
);

InfoBanner.Actions = BannerActions;
InfoBanner.Content = BannerContent;
InfoBanner.Icon = BannerIcon;
InfoBanner.Text = BannerText;

export default InfoBanner;
